// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.el-tree-node>div.el-tree-node__children {\n  overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
